module.exports = {
  datetime: {
    year: '',
    month: '',
    fullMonth: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    shortMonth: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'June',
      'July',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec'
    ],
    weekday: [
      'Su',
      'Mo',
      'Tu',
      'We',
      'Th',
      'Fr',
      'Sa'
    ],
    format: {
      year: 'yyyy',
      month: 'MM',
      date: 'yyyy-MM-dd',
      datetime: 'yyyy-MM-dd hh:mm:ss',
      time: 'hh:mm:ss'
    },
    prev: 'prev',
    next: 'next'
  }
}




// WEBPACK FOOTER //
// ./~/rctui/lang/en/datetime.js